import {
  post
} from "@/utils/utils";

const orderCenter = {
  state: {
    orderCenterList: {
      storeOrderBasicInfoModelPage: {}
    },
    orderAllCenterList: {
      storeOrderBasicInfoModelPage: {}
    },
    detailsOrder: {
      order: {
        deliveryType: "",
        receiptSn: ""
      },
      orderStatus: [{
        orderStatus: ""
      }]
    },
    detailsExpressOrder: {
      order: {
        deliveryType: "",
        receiptSn: ""
      },
      orderStatus: [{
        orderStatus: ""
      }]
    },
    newDetailsOrder: {
      order: {
        deliveryType: "",
        receiptSn: ""
      },
      orderStatus: [{
        orderStatus: ""
      }]
    },
    logisticsList: {},
    showLogsistics: {
      order: {},
      courierInfo: {
        traces: []
      }
    },
    invoiceList: {
      number: {},
      order: {}
    },
    expressList: {},
    expressModeList: {},
    feeCalcModeList: {},
    storeExpressList: {},
    cityList: {},
    detailsStoreExpres: {},
    detailsAdres: {
      records: []
    },
    expressShopList: {},
    expressPageList: {},
    querySupplier: {},
    offlineOrderList: {}
  },
  mutations: {
    QUERY_OFFLINE_ORDER_LIST() {},
    QUERY_ORDER_LIST(state, data) {
      state.orderCenterList = data.result;
    },
    QUERY_ALL_INVOICE_LIST(state, data) {
      state.orderAllCenterList = data.result;
    },
    DETAIL_ORDER(state, data) {
      state.detailsOrder = data.result;
    },
    NEW_DETAIL_ORDER(state, data) {
      state.newDetailsOrder = data.result;
    },
    LOGISTICS_LIST(state, data) {
      state.logisticsList = data.result;
    },
    ADD_ORDER(state, data) {
      state.addorder = data.result;
    },
    APPOIN_TOUTLET(state, data) {
      state.appointOutle = data.result;
    },
    SURE_ARRIVE(state, data) {
      state.sure = data.result;
    },
    DELIVER_ORDER(state, data) {
      state.delive = data.result;
    },
    SHOW_LOGSISTICS(state, data) {
      state.showLogsistics = data.result;
      // state.showLogsistics.courierInfo = data.result.order.courierInfo || {
      //   traces: []
      // };
      state.showLogsistics.courierInfo.traces.reverse();
    },
    QUERY_INVOICE_LIST(state, data) {
      state.invoiceList = data.result;
      state.invoiceList.order.records.forEach(v => {
        v.disabled = true;
      });
    },
    ALL_QUERY_INVOICE_LIST(state, data) {
      state.allInvoiceList = data.result;
      // state.invoiceList.order.records.forEach(v => {
      //   v.disabled = true;
      // });
    },
    QUERY_LOCAL_EXPRESS_LIST(state, data) {
      state.expressList = data.result;
    },
    QUERY_EXPRESS_MODE_LIST(state, data) {
      state.expressModeList = data.result;
    },
    QUERY_FEE_CALC_MODE_LIST(state, data) {
      state.feeCalcModeList = data.result;
    },
    SAVE_LOCAL_EXPRESS_CONFIG(state, data) {
      state.saveExpressInfo = data.result;
    },
    DETAILS_EXPRESS(state, data) {
      state.detailsExpres = data.result;
    },
    EDIT_EXPRESS(state, data) {
      state.detailsExpres = data.result;
    },
    QUERY_STORE_EXPRESS_LIST(state, data) {
      state.storeExpressList = data.result;
    },
    QUERY_FEE_CALC_MODE_LIST2(state, data) {
      state.feeCalcModeList2 = data.result;
    },
    QUERY_REGION_CODE(state, data) {
      state.cityList = data.result;
    },
    SAVE_STORE_EXPRESS_CONFIG(state, data) {
      state.saveStoreExpress = data.result;
    },
    DETAILS_STORE_EXPRESS(state, data) {
      state.detailsStoreExpres = data.result;
    },
    EDIT_STORE_EXPRESS(state, data) {
      state.editStoreExpress = data.result;
    },
    Detail_DETAL_SET(state, data) {
      state.detailSetting = data.result;
    },
    // ADD_SETTING(state, data) {
    //   state.addSet = data.result;
    // },
    EDIT_SETTING(state, data) {
      state.editSet = data.result;
    },
    DETAILS_ADDRESS(state, data) {
      state.detailsAdres = data.result ?
        data.result :
        {
          records: []
        };
    },
    BATCH_ORDER_RECORD(state, data) {
      state.batchOrder = data.result;
    },
    BATCH_PRINT_OEDER_LIST(state, data) {
      state.batchPrintOrderList = data.result;
    },
    EXPRESS_PUT(state, data) {
      state.expressPut = data.result;
    },
    ORDER_PRINT(state, data) {
      state.orderPrint = data.result;
    },
    EXPRESS_SHOP_LIST(state, data) {
      state.expressShopList = data.result;
    },
    EXPRESS_PAGE_LIST(state, data) {
      state.expressPageList = data.result;
    },
    EXPRESS_SAVE(state, data) {
      state.expressAdd = data.result;
    },
    UPDATE_EXPRESS(state, data) {
      state.updateExpress = data.result;
    },
    QUERY_SUPPLIER(state, data) {
      state.querySupplier = data.result;
    },
    EDIT_ORDER() {},
    DETAIL_ORDER_LIST() {},
    ORDER_PUSH_SUPPLY() {},
    QUERY_SUPPLIER_INFO_LIST() {},
    SAVE_SUPPLIER_INFO() {},
    DETAILS_SUPPLIER_INFO() {},
    EDIT_SUPPLIER_INFO() {},
    DEL_SUPPLIER_INFO() {},
    QUERY_EXPRESS_ORDER_PAGE() {},
    QUERY_EXPRESS_ORDER_PAGE_TO_SHORTCUT() {},
    IMPORT_EXPRESS_TO_SHORTCUT() {},
    IMPORT_EXPRESS_TO_SHORTCUT_BATCH_SAVE() {},
    QUERY_ALL_EXPRESS_ORDER_PAGE() {},
    EXPRESS_ORDER_PART() {},
    APPINT_SHOP() {},
    EXPRESS_ORDER_GUAQI() {},
    EDIT_EXPRESS_ORDER_GUAQI() {},
    SHOW_EXPRESS_ORDER(state, data) {
      state.detailsExpressOrder = data.result;
    },
    QUERY_SUPPLIER_BOX() {},
    QUERY_THIRD_EXPRESS_ORDER_DETAILS_LIST() {},
    EXCEL_EXPRESS_ORDER_DETAILS_PART() {},
    ORDER_RETURN_PUT() {},
    QUERY_OFFLINE_ORDER_DETAILS() {},
    OFFLINE_ORDER_COUPON_SEND() {},
    DEL_STORE_EXPRESS() {},
    ADD_PRINT_NUM() {},
    QUERY_NEW_ORDER_LIST() {},
    QUERY_ALL_SUPPLIER_INFO_LIST() {},
    QUERY_ORDER_DETAILS() {},
    EDIT_GOODS_REMARK() {},
    EDIT_EXPRESS_ORdER_SN() {},
    QUERY_REGION_CITY() {},
    SAVE_STORE_EXPRESS_NEW() {},
    QUERY_EXPRESS_CONFIG_LIST() {},
    DEIT_EXPRESS_CONFIG_NEW() {},
    DETAILS_EXPRESS_CONFIG_NEW() {},
    CHECK_SPU_EXPRESS_REL() {},
    GET_POPVER() {},
    CANCLE_REFUND_INFO() {},
    GET_SINGLEAPECGOODS() {},
    GET_WITHMOBILE() {},
    GET_BRANCH() {},
    GET_POSORDER() {},
    GET_GOODSSN() {},
    GET_RECEIPTSN() {},
    GOODS_BY_ATTACH_BARCODES() {},
    GOODS_BY_HEMIAO_CODES() {},
    GET_DEPART() {},
    GET_SHOP() {},
    GET_CARDTYPE() {},
    GET_DEPORT() {},
    GET_EMPLOYEE() {},
    GET_BRAND() {},
    GET_CATEGORY() {},
    GET_SPEC() {},
    GET_ASSISTAR() {},
    EXPORT_ORDER_LIST() {},
    EXPORT_ORDER_DETAILS_LIST() {},
    ASSIGN_ORDER_SHOP() {},
    QUERY_THIRD_EXPORT_INFO_LIST() {},
    QUERY_THIRD_EXPORT_INFO() {},
    EDIT_THIRD_EXPORT_INFO() {},
    SAVE_THIRD_EXPORT_INFO() {},
    QUERY_ORDER_INFO() {},
    QUERY_DELIVER_FEE() {},
    ADD_AFTER_QUERY() {},
    QUERY_ORDER_STATUS() {},
    QUERY_CANCEL_REASONS() {},
    CANCEL_DADA_ORDER() {},
    STORE_SHOP_INFO_MESSAGE() {},
    QUERY_ORDER_PUSH_ERROR_LIST() {},
    QUERY_ORDER_PUSH_ERROR_DETAIL() {},
    QUERY_ORDER_PUSH_ERROR_HANDLE() {},
    EXPOET_STORE_MINIPROG_SCAN() {},
    MOP_ORDER_PUSH_ERROR_DETAIL() {},
    MOP_ORDER_PUSH_ERROR_HANDLE() {},
    OVERSEAS_EXCEPTION_ORDER_LIST() {},
    OVERSEAS_EXCEPTION_ORDER_HANDLE() {},
    EXPORT() {},
    ATTR_BARCODE_IMPORT() {},
    IMPORT_GOODS_BY_HEMIAOCODES() {},
    RE_WRITE_GOODS_SN() {},
    GET_EXPRESS_INFO() {},
    RE_ADD_ORDER() {},
    SAVE_OPERATE_MEMO() {},
    QUERY_OPERATE_MEMO() {},
    APPLY_RETURN_GOODS() {},
    REFUND_MAKE_SENSE() {},
    BATCH_WRITE_ORDER() {},
    OVERDUE_APPLY_REFUND_UPDATE_OAOPERATE_RESULT() {},
    SAOBEI_CONFIG_LIST() {},
    EDIT_GOODS_EXPRESS_ORDER_DETAILS_REMARK() {},
    QUERY_EXPRESS_ORDER_STAT() {}
  },
  actions: {
    queryOfflineOrderDetails({
      commit
    }, params) {
      return post({
        commit,
        url: `/orderPos/orderPosDetail`,
        name: "QUERY_OFFLINE_ORDER_DETAILS",
        params
      });
    },
    offlineOrderSend({
      commit
    }, params) {
      return post({
        commit,
        url: `/orderPos/reissueCoupons`,
        name: "OFFLINE_ORDER_COUPON_SEND",
        params
      });
    },
    queryOfflineOrderList({
      commit
    }, params) {
      return post({
        commit,
        url: `/orderPos/orderPosList`,
        name: "QUERY_OFFLINE_ORDER_LIST",
        params
      });
    },
    queryOrderCenterList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/list`,
        name: "QUERY_ORDER_LIST",
        params
      });
    },
    queryAllOrderCenterList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/list`,
        name: "QUERY_ALL_INVOICE_LIST",
        params
      });
    },
    newDetailOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/show_order_new`,
        name: "NEW_DETAIL_ORDER",
        params
      });
    },
    // detailOrder({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/order/show_order_new`,
    //     name: "DETAIL_ORDER",
    //     params
    //   });
    // },
    detailOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/show_order`,
        name: "DETAIL_ORDER",
        params
      });
    },
    detailOrderList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/details_list`,
        name: "DETAIL_ORDER_LIST",
        params
      });
    },
    logistics({
      commit
    }) {
      return post({
        commit,
        url: `/courier/hmCourier/findCourierCodeList`,
        name: "LOGISTICS_LIST"
      });
    },
    addOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/addMsg`,
        name: "ADD_ORDER",
        params
      });
    },
    appointOutlet({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/appoint_outlet`,
        name: "APPOIN_TOUTLET",
        params
      });
    },
    sureArrive({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/take_order`,
        name: "SURE_ARRIVE",
        params
      });
    },
    deliverOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/deliver_order`,
        name: "DELIVER_ORDER",
        params
      });
    },
    showLogsistics({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/showLogsistics`,
        name: "SHOW_LOGSISTICS",
        params
      });
    },
    queryInvoiceList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/query_task_list`,
        name: "QUERY_INVOICE_LIST",
        params
      });
    },
    queryAllInvoiceList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/query_task_list`,
        name: "ALL_QUERY_INVOICE_LIST",
        params
      });
    },
    queryLocalExpressList({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeLocalExpressConfig/findStoreLocalExpressList`,
        name: "QUERY_LOCAL_EXPRESS_LIST",
        params
      });
    },
    queryExpressModeList({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=express_mode`,
        name: "QUERY_EXPRESS_MODE_LIST",
        params
      });
    },
    queryFeeCalcModeList({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=fee_calc_mode3`,
        name: "QUERY_FEE_CALC_MODE_LIST",
        params
      });
    },
    saveLocalExpressConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeLocalExpressConfig/saveLocalExpressConfig`,
        name: "SAVE_LOCAL_EXPRESS_CONFIG",
        params
      });
    },
    detailsExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeLocalExpressConfig/findLocalExpressConfigById`,
        name: "DETAILS_EXPRESS",
        params
      });
    },
    editExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeLocalExpressConfig/editLocalExpressConfig`,
        name: "EDIT_EXPRESS",
        params
      });
    },
    queryStoreExpressList({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/findStoreExpressList`,
        name: "QUERY_STORE_EXPRESS_LIST",
        params
      });
    },
    queryFeeCalcModeList2({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=fee_calc_mode2`,
        name: "QUERY_FEE_CALC_MODE_LIST2",
        params
      });
    },
    queryRegionCode({
      commit
    }, params) {
      return post({
        commit,
        url: `/regionCode/findRegionCode`,
        name: "QUERY_REGION_CODE",
        params
      });
    },
    saveStoreExpressConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/saveStoreExpressConfig`,
        name: "SAVE_STORE_EXPRESS_CONFIG",
        params
      });
    },
    detailsStoreExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/findStoreExpressById`,
        name: "DETAILS_STORE_EXPRESS",
        params
      });
    },
    delStoreExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/delStoreExpress`,
        name: "DEL_STORE_EXPRESS",
        params
      });
    },
    editStoreExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/editStoreExpressConfig`,
        name: "EDIT_STORE_EXPRESS",
        params
      });
    },
    configDetail({
      commit
    }) {
      return post({
        commit,
        url: `/sys/config/order/config_detail`,
        name: "Detail_DETAL_SET"
      });
    },
    // addSetting({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/config/batch_add`,
    //     name: "ADD_SETTING",
    //     params
    //   });
    // },
    editSetting({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/config/batch_edit`,
        name: "EDIT_SETTING",
        params
      });
    },
    detailsAddress({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/findStoreExpressConfig`,
        name: "DETAILS_ADDRESS",
        params
      });
    },
    batchOrderRecord({
      commit
    }, params) {
      return post({
        commit,
        url: `order/order_record_list`,
        name: "BATCH_ORDER_RECORD",
        params
      });
    },
    batchPrintOrderList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/print_order_list_new`,
        name: "BATCH_PRINT_OEDER_LIST",
        params
      });
    },
    // batchPrintOrderList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `order/print_order_list`,
    //     name: "BATCH_PRINT_OEDER_LIST",
    //     params
    //   });
    // },
    expressPut({
      commit
    }, params) {
      return post({
        commit,
        url: `order/express_put`,
        name: "EXPRESS_PUT",
        params
      });
    },
    orderPrint({
      commit
    }, params) {
      return post({
        commit,
        url: `shop/order/order_print`,
        name: "ORDER_PRINT",
        params
      });
    },
    expressShopList({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/express_shop_list`,
        name: "EXPRESS_SHOP_LIST",
        params
      });
    },
    expressPageList({
      commit
    }, params) {
      return post({
        commit,
        url: `express/page_list`,
        name: "EXPRESS_PAGE_LIST",
        params
      });
    },
    expressSave({
      commit
    }, params) {
      return post({
        commit,
        url: `express/save_express`,
        name: "EXPRESS_SAVE",
        params
      });
    },
    updateExpress({
      commit
    }, params) {
      return post({
        commit,
        url: `express/update_express`,
        name: "UPDATE_EXPRESS",
        params
      });
    },
    querySupplier({
      commit
    }, params) {
      return post({
        commit,
        url: `/noauth/supplier_bill/querySupplier`,
        name: "QUERY_SUPPLIER",
        params
      });
    },
    editRemark({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/editRemark`,
        name: "EDIT_ORDER",
        params
      });
    },
    orderPushSupply({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/order_push_supply`,
        name: "ORDER_PUSH_SUPPLY",
        params
      });
    },
    querySupplierInfoList({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/findSupplierInfoList`,
        name: "QUERY_SUPPLIER_INFO_LIST",
        params
      });
    },
    queryAllSupplierInfoList({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/findSupplierInfoList`,
        name: "QUERY_ALL_SUPPLIER_INFO_LIST",
        params
      });
    },
    saveSupplierInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/saveSupplierInfo`,
        name: "SAVE_SUPPLIER_INFO",
        params
      });
    },
    detailsSupplierInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/findSupplierInfoById`,
        name: "DETAILS_SUPPLIER_INFO",
        params
      });
    },
    editSupplierInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/editSupplierInfo`,
        name: "EDIT_SUPPLIER_INFO",
        params
      });
    },
    delSupplierInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/delSupplierInfo`,
        name: "DEL_SUPPLIER_INFO",
        params
      });
    },
    queryExpressOrderPage({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/findExpressOrderPage`,
        name: "QUERY_EXPRESS_ORDER_PAGE",
        params
      });
    },
    importExpressToShortcut({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/importExpressToShortcut`,
        name: "IMPORT_EXPRESS_TO_SHORTCUT",
        params
      });
    },
    importExpressToShortcutBatchSave({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/importExpressToShortcutBatchSave`,
        name: "IMPORT_EXPRESS_TO_SHORTCUT_BATCH_SAVE",
        params
      });
    },
    findExpressOrderPageToShortcut({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/findExpressOrderPageToShortcut`,
        name: "QUERY_EXPRESS_ORDER_PAGE_TO_SHORTCUT",
        params
      });
    },
    queryAllExpressOrderPage({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/findExpressOrderPage`,
        name: "QUERY_ALL_EXPRESS_ORDER_PAGE",
        params
      });
    },
    // 查询快递订单统计
    queryExpressOrderStat({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/findExpressOrderStat`,
        name: "QUERY_EXPRESS_ORDER_STAT",
        params
      });
    },
    expressOrderPart({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/expressOrderPart`,
        name: "EXPRESS_ORDER_PART",
        params
      });
    },
    appointShop({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/appointShop`,
        name: "APPINT_SHOP",
        params
      });
    },
    expressOrderGuaqiverify({
      commit
    }, params) {
      return post({
        commit,
        url: `order/expressOrderGuaqiverify`,
        name: "EXPRESS_ORDER_GUAQI",
        params
      });
    },
    editExpressOrderGuaqi({
      commit
    }, params) {
      return post({
        commit,
        url: `order/editExpressOrderGuaqi`,
        name: "EDIT_EXPRESS_ORDER_GUAQI",
        params
      });
    },
    showExpressOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `order/show_express_order`,
        name: "SHOW_EXPRESS_ORDER",
        params
      });
    },
    querySupplierInfoComboBox({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeSupplierInfo/findSupplierInfoComboBox`,
        name: "QUERY_SUPPLIER_BOX",
        params
      });
    },
    queryThirdExpressOrderDetailsList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/findThirdExpressOrderDetailsList`,
        name: "QUERY_THIRD_EXPRESS_ORDER_DETAILS_LIST",
        params
      });
    },
    excelExpressOrderDetailsPart({
      commit
    }, params) {
      return post({
        commit,
        url: `order/excelExpressOrderDetailsPart`,
        name: "EXCEL_EXPRESS_ORDER_DETAILS_PART",
        params
      });
    },
    orderReturnPut({
      commit
    }, params) {
      return post({
        commit,
        url: `order/order_return_put`,
        name: "ORDER_RETURN_PUT",
        params
      });
    },
    addExpressPrintNum({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/addExpressPrintNum`,
        name: "ADD_PRINT_NUM",
        params
      });
    },
    queryNewOrderList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/list_new`,
        name: "QUERY_NEW_ORDER_LIST",
        params
      });
    },
    queryOrderDetails({
      commit
    }, params) {
      return post({
        commit,
        url: `order/query_order_details`,
        name: "QUERY_ORDER_DETAILS",
        params
      });
    },
    editGoodsRemark({
      commit
    }, params) {
      return post({
        commit,
        url: `order/edit_goods_remark`,
        name: "EDIT_GOODS_REMARK",
        params
      });
    },
    editExpressSn({
      commit
    }, params) {
      return post({
        commit,
        url: `order/edit_expressOrderSn`,
        name: "EDIT_EXPRESS_ORdER_SN",
        params
      });
    },
    queryRegionCodeProvCity({
      commit
    }, params) {
      return post({
        commit,
        url: `/regionCode/queryRegionCodeProvCity`,
        name: "QUERY_REGION_CITY",
        params
      });
    },
    saveStoreExpressConfigNew({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/saveStoreExpressConfigNew`,
        name: "SAVE_STORE_EXPRESS_NEW",
        params
      });
    },
    storeExpressConfigList({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/storeExpressConfigList`,
        name: "QUERY_EXPRESS_CONFIG_LIST",
        params
      });
    },
    editStoreExpressConfigNew({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/editStoreExpressConfigNew`,
        name: "DEIT_EXPRESS_CONFIG_NEW",
        params
      });
    },
    detailsStoreExpressConfigNew({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/expressConfigDetails`,
        name: "DETAILS_EXPRESS_CONFIG_NEW",
        params
      });
    },
    checkSpuExpressRel({
      commit
    }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/checkSpuExpressRel`,
        name: "CHECK_SPU_EXPRESS_REL",
        params
      });
    },
    getRemark({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_remark`,
        name: "GET_POPVER",
        params
      });
    },
    getSinglespecgoods({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_singlespecgoods`,
        name: "GET_SINGLEAPECGOODS",
        params
      });
    },
    getWithmobile({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_withmobile`,
        name: "GET_WITHMOBILE",
        params
      });
    },
    getBranch({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_branch`,
        name: "GET_BRANCH",
        params
      });
    },
    getPosorder({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_posorder`,
        name: "GET_POSORDER",
        params
      });
    },
    getGoodsSn({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_goodsSn`,
        name: "GET_GOODSSN",
        params
      });
    },
    getReceiptSn({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=query_unique_order_info_by_receipt_sn`,
        name: "GET_RECEIPTSN",
        params
      });
    },
    getGoodsByAttachBarcodes({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_goodsByAttachBarcodes`,
        name: "GOODS_BY_ATTACH_BARCODES",
        params
      });
    },
    getGoodsbyhemiaocodes({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_goodsByHemiaocodes`,
        name: "GOODS_BY_HEMIAO_CODES",
        params
      });
    },
    getDepart({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_depart`,
        name: "GET_DEPART",
        params
      });
    },
    getShop({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_shop`,
        name: "GET_SHOP",
        params
      });
    },
    getCardtype({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_cardtype`,
        name: "GET_CARDTYPE",
        params
      });
    },
    getDepot({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_depot`,
        name: "GET_DEPORT",
        params
      });
    },
    getEmployee({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_employee`,
        name: "GET_EMPLOYEE",
        params
      });
    },
    getBrand({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_brand`,
        name: "GET_BRAND",
        params
      });
    },
    getCategory({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_category`,
        name: "GET_CATEGORY",
        params
      });
    },
    getSpec({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_spec`,
        name: "GET_SPEC",
        params
      });
    },
    getAssistattribute({
      commit
    }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=target_sync_assistattribute`,
        name: "GET_ASSISTAR",
        params
      });
    },
    cancleRefundInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/cancle_refund_info`,
        name: "CANCLE_REFUND_INFO",
        params
      });
    },
    refundMakeSense({
                       commit
                     }, params) {
      return post({
        commit,
        url: `/order/refundMakeSense`,
        name: "REFUND_MAKE_SENSE",
        params
      });
    },
    exportOrderList({
      commit
    }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/list_new_export?false`,
        name: "EXPORT_ORDER_LIST",
        params
      });
    },
    exportOrderListPlus({
      commit
    }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/list_new_export_plus?false`,
        name: "EXPORT_ORDER_LIST_PLUS",
        params
      });
    },
    exportOrderDetailsList({
      commit
    }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/order_details_export?false`,
        name: "EXPORT_ORDER_DETAILS_LIST",
        params
      });
    },
    exportOrderDetailsListPlus({
      commit
    }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/order_details_export_plus?false`,
        name: "EXPORT_ORDER_DETAILS_LIST_PLUS",
        params
      });
    },
    assignOrderShop({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/assignOrderShop`,
        name: "ASSIGN_ORDER_SHOP",
        params
      });
    },
    queryThirdExpressInfoList({
      commit
    }, params) {
      return post({
        commit,
        url: `/system/thirdInterfaceInfo/queryThirdExpressInfoList`,
        name: "QUERY_THIRD_EXPORT_INFO_LIST",
        params
      });
    },
    queryThirdExpressInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/system/thirdInterfaceInfo/queryThirdExpressInfo`,
        name: "QUERY_THIRD_EXPORT_INFO",
        params
      });
    },
    editThirdExpressInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/system/thirdInterfaceInfo/editThirdExpressInfo`,
        name: "EDIT_THIRD_EXPORT_INFO",
        params
      });
    },
    saveThirdExpressInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/system/thirdInterfaceInfo/saveThirdExpressInfo`,
        name: "SAVE_THIRD_EXPORT_INFO",
        params
      });
    },
    queryOrderInfo({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/queryOrderInfo`,
        name: "QUERY_ORDER_INFO",
        params
      });
    },
    queryDeliverFee({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryDeliverFee`,
        name: "QUERY_DELIVER_FEE",
        params
      });
    },
    addAfterQuery({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/addAfterQuery`,
        name: "ADD_AFTER_QUERY",
        params
      });
    },
    queryOrderStatus({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryOrderStatus`,
        name: "QUERY_ORDER_STATUS",
        params
      });
    },
    queryCancelReasons({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryCancelReasons`,
        name: "QUERY_CANCEL_REASONS",
        params
      });
    },
    cancelDaDaOrder({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/cancelDaDaOrder`,
        name: "CANCEL_DADA_ORDER",
        params
      });
    },
    storeShopInfoMessageConfirm({
      commit
    }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/messageConfirm`,
        name: "STORE_SHOP_INFO_MESSAGE",
        params
      });
    },
    queryOrderPushErrorList({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/order_push_error_List`,
        name: "QUERY_ORDER_PUSH_ERROR_LIST",
        params
      });
    },
    overSeasExceptionOrderList({
                              commit
                            }, params) {
      return post({
        commit,
        url: `/order/queryStoreErrorOverseasOrderList`,
        name: "OVERSEAS_EXCEPTION_ORDER_LIST",
        params
      });
    },
    // 跨境订单补写忽略
    overSeasOrderPushErrorHandle({
                              commit
                            }, params) {
      return post({
        commit,
        url: `/order/operationErrorOverseasOrder`,
        name: "OVERSEAS_EXCEPTION_ORDER_HANDLE",
        params
      });
    },
    queryOrderPushErrorDetail({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/order_push_error_detail`,
        name: "QUERY_ORDER_PUSH_ERROR_DETAIL",
        params
      });
    },
    // 订单异常操作
    mopOrderPushErrorDetail({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/mopOrderPushErrorDetail`,
        name: "MOP_ORDER_PUSH_ERROR_DETAIL",
        params
      });
    },
    // 忽略和补写
    mopOrderPushErrorHandle({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/mopOrderPushErrorHandle`,
        name: "QUERY_ORDER_PUSH_ERROR_HANDLE",
        params
      });
    },
    //昆明订单更改订单货号重写mop
    reWriteGoodsSn({ commit}, params) {
      return post({
        commit,
        url: `/order/reWriteGoodsSn`,
        name: "RE_WRITE_GOODS_SN",
        params
      });
    },

    queryOrderPushErrorHandle({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/order_push_error_handle`,
        name: "QUERY_ORDER_PUSH_ERROR_HANDLE",
        params
      });
    },
    exportStoreMiniprogScan({
      commit
    }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/exportStoreMiniprogramScan`,
        name: "EXPOET_STORE_MINIPROG_SCAN",
        params
      });
    },
    export({commit}, params) {
      return post({
        commit,
        url: `/order/public_export`,
        name: "EXPORT",
        params
      });
    },
    attrBarCodeImport({commit}, params) {
      return post({
        commit,
        url: `/thirderp/syncGoodsByAttachBarcodes`,
        name: "ATTR_BARCODE_IMPORT",
        params
      });
    },
    importGoodsByHemiaocodes({commit}, params) {
      return post({
        commit,
        url: `/thirderp/importGoodsByHemiaocodes`,
        name: "IMPORT_GOODS_BY_HEMIAOCODES",
        params
      });
    },
    getExpressInfo({commit}, params) {
      return post({
        commit,
        url: `/provider/order/micro/express/getExpressInfo`,
        name: "GET_EXPRESS_INFO",
        params
      });
    },
    reAddOrder({commit}, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/reAddOrder`,
        name: "RE_ADD_ORDER",
        params
      });
    },
    saveOperateMemo({commit}, params) {
      return post({
        commit,
        url: `/log/sysOperateMemoLog/saveOperateMemo`,
        name: "SAVE_OPERATE_MEMO",
        params
      });
    },
    queryOperateMemo({commit}, params) {
      return post({
        commit,
        url: `/log/sysOperateMemoLog/queryPageList`,
        name: "QUERY_OPERATE_MEMO",
        params
      });
    },
    applyReturnGoods({commit}, params) {
      return post({
        commit,
        url: `/order/apply_return_goods`,
        name: "APPLY_RETURN_GOODS",
        params
      });
    },
    batchWriteOrder({commit}, params) {
      return post({
        commit,
        url: `/order/batchWriteOrder`,
        name: "BATCH_WRITE_ORDER",
        params
      });
    },
    overdueApplyRefundUpdateOAOperateResult({commit}, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/overdueApplyRefundUpdateOAOperateResult`,
        name: "OVERDUE_APPLY_REFUND_UPDATE_OAOPERATE_RESULT",
        params
      });
    },
    saobeiConfigList({commit}, params) {
      return post({
        commit,
        url: `/saobei/config/list`,
        name: "SAOBEI_CONFIG_LIST",
        params
      });
    },
    // 新备注
    editGoodsExpressOrderDetailsRemark({
      commit
    }, params) {
      return post({
        commit,
        url: `/order/editGoodsExpressOrderDetailsRemark`,
        name: "EDIT_GOODS_EXPRESS_ORDER_DETAILS_REMARK",
        params
      });
    },
  }
};

export default orderCenter;
